const BR_AGGREGATE_PRODUCT_KEYS = new Set(['TODOS_OS_PRODUTOS', 'TODOS_PRODUTOS'])

const getActiveNotificationProductIds = (
  isUSBranch: boolean,
  productMenu?: Record<string, { isActive?: boolean }>,
): string[] => {
  if (!productMenu) return []

  return Object.entries(productMenu)
    .filter(([productKey, product]) => {
      if (product.isActive === false) return false
      if (!isUSBranch && BR_AGGREGATE_PRODUCT_KEYS.has(productKey)) return false

      return true
    })
    .map(([productKey]) => productKey)
}

export { getActiveNotificationProductIds }
